export default function FormatDate(date: any) {
  return date.replace('T', ' ').split('.')[0]
}
